// Material Dashboard 2 React example components
import { Card, CardHeader, CardContent } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

const ListVariable = () => {
  const handleClick = (text) => {
    if (document.hasFocus()) {
      navigator.clipboard.writeText(text);
    }
  };

  const list = [
    "{{NOMBRE}}",
    "{{CARATULA}}",
    "{{NUMERO}}",
    "{{AÑO}}",
    "{{JURISDICCIÓN}}",
    "{{DEPENDENCIA}}",
    "{{FECHA_PERICIA}}",
    "{{LINK_PERICIA}}",
    "{{PARTE_REPRESENTADA}}",
  ];

  return (
    <Card>
      <CardHeader title="Variables" sx={{ pb: 0 }} />
      <CardContent>
        <MDBox component="ul" display="flex" flexDirection="column" pb={0} m={0}>
          {list.map((item) => (
            <MDBox
              key={item}
              py={0.5}
              onClick={() => handleClick(item)}
              sx={{
                display: "flex",
                transition: "0.3s",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <ContentCopy fontSize="small" color="text" sx={{ mr: 2 }}></ContentCopy>
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ userSelect: "none" }}
              >
                {item}
              </MDTypography>
            </MDBox>
          ))}
        </MDBox>
      </CardContent>
    </Card>
  );
};
export default ListVariable;
